module.exports = __webpack_public_path__ + "img/img_wallet.4d373ccb.png";